module.exports = __webpack_public_path__ + "img/Orbiting-1-mobile.493cfbc3.png";